import {Typography} from 'components/Typography';
import {selectProductData} from 'modules/product-card/selectors';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {DiscountPercentLabel} from 'modules/product-card/components/DiscountPercentLabel';
import {ProductShieldSuperPrice} from 'modules/product-card/components/ProductShieldSuperPrice';
import {ProductShieldOnlineEcom} from 'modules/product-card/components/ProductShieldOnlineEcom';
import {useProductBasePrice} from 'hooks/product/useProductBasePrice';
import {useProductIsPriceRed} from 'hooks/product/useProductIsPriceRed';
import {useProductResultPrice} from 'hooks/product/useProductResultPrice';
import {ProductShieldPricePerOne} from 'modules/product-card/components/ProductShieldPricePerOne';
import classNames from 'classnames';
import {FC} from 'react';
import style from './style.module.scss';
import {useIsProductFineAndRare} from 'modules/product-card/hooks/useIsProductFineAndRare';
import {CashbackLabel} from 'components/CashbackLabel';
import {Button} from 'components/Button';
import Icon from 'components/Icon';
import {showModal} from 'modules/modals/thunks';
import {MODALS} from 'modules/modals/constants';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {useInView} from 'react-intersection-observer';
import {useLoyaltyRestrictionInformerGtag} from 'modules/product-card/analytics/gtag/hooks/useLoyaltyRestrictionInformerGtag';

export const ProductPriceBlockMobile: FC = () => {
    const productData = useAppSelector(selectProductData);

    const hasLoyaltyRestrictions = Boolean(productData?.price?.loyaltyRestrictionHint);
    const isPriceRed = useProductIsPriceRed(productData);
    const basePrice = useProductBasePrice(productData);
    const resultPrice = useProductResultPrice(productData);
    const isFineAndRareCategory = useIsProductFineAndRare();
    const dispatch = useAppDispatch();

    const {handleLoyaltyRestrictionIconClick, handleLoyaltyRestrictionIconInView} = useLoyaltyRestrictionInformerGtag({
        product: productData ? {id: productData.id, title: productData.title, price: productData.price} : null,
    });

    const {ref: loyaltyRestrictionIconRef} = useInView({
        triggerOnce: true,
        onChange: (inView) => {
            handleLoyaltyRestrictionIconInView(inView);
        },
    });

    const showLoyaltyRestrictionInfo = () => {
        handleLoyaltyRestrictionIconClick();
        dispatch(showModal(MODALS.PRODUCT_LOYALTY_RESTRICTION_MODAL.name));
    };

    return (
        <>
            <div className={style.main}>
                {!isFineAndRareCategory && (
                    <div className={style.shieldsArea}>
                        <ProductShieldPricePerOne />
                        <ProductShieldSuperPrice />
                        <ProductShieldOnlineEcom />
                        {/* <ProductShieldGrowingDiscount />*/}
                    </div>
                )}

                <div>
                    {!isFineAndRareCategory && basePrice && (
                        <Typography className={style.priceBase} variant={'label-16-r'}>
                            {basePrice}
                        </Typography>
                    )}
                    <div className={style.priceMainBlock}>
                        <Typography className={classNames(style.price, isPriceRed ? style.priceRed : '')}>
                            {resultPrice}
                        </Typography>
                        {!isFineAndRareCategory && <DiscountPercentLabel type={'small'} borderRadius={'4px'} />}
                        <CashbackLabel
                            value={productData?.price?.cashback}
                            className={style.cashback}
                            withShortForm={false}
                            withTooltip={true}
                        />

                        {hasLoyaltyRestrictions && (
                            <span ref={loyaltyRestrictionIconRef}>
                                <Button
                                    onClick={showLoyaltyRestrictionInfo}
                                    size={'unset'}
                                    className={style.infoButton}
                                    theme={'unset'}
                                >
                                    <Icon icon={'info-new-light-stroke'} />
                                </Button>
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
